import { Expose } from "class-transformer";
import { observable } from "mobx";

export default class AdminPartnersFilter {
  @observable
  @Expose({ name: "q" })
  search?: string;
}
